import React, { useEffect, useState } from 'react'
import { Button, Stack, Tooltip } from '@mui/material'

import { B2BQr, C2BQr, Nullable } from '../../types.ts'
import { EMPTY_VALUE } from '../../constants.ts'
import { ShareQrDialog } from '../share-qr-dialog.tsx'

export type QrLinkProps = (C2BQr | B2BQr) & {
  value: Nullable<string>
}

export const QrLink = ({ value, ...row }: QrLinkProps): React.ReactElement => {
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false)
      }, 1000)
    }
  }, [copied])

  const handleFastCopy = () => {
    if (value) {
      try {
        navigator.clipboard.writeText(value)
        setCopied(true)
      } catch (e) {
        console.log(29, e)
      }
    }
  }
  if (!value) {
    return <>{EMPTY_VALUE}</>
  }

  return (
    <Stack gap={1} direction="row">
      <Tooltip
        title="Скопировано!"
        open={copied}
        placement="top"
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -10],
              },
            },
          ],
        }}
      >
        <Button color="primary" onClick={handleFastCopy}>
          Скопировать
        </Button>
      </Tooltip>
      <ShareQrDialog url={value} image={row.image} requestId={row.requestId} type={row.type} qrcType={row.qrcType} />
    </Stack>
  )
}
